/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IntermediaryClientRelationshipViewModel } from './IntermediaryClientRelationshipViewModel';
import {
    IntermediaryClientRelationshipViewModelFromJSON,
    IntermediaryClientRelationshipViewModelFromJSONTyped,
    IntermediaryClientRelationshipViewModelToJSON,
} from './IntermediaryClientRelationshipViewModel';
import type { ResultStates } from './ResultStates';
import {
    ResultStatesFromJSON,
    ResultStatesFromJSONTyped,
    ResultStatesToJSON,
} from './ResultStates';

/**
 * 
 * @export
 * @interface ResultOfListOfIntermediaryClientRelationshipViewModel
 */
export interface ResultOfListOfIntermediaryClientRelationshipViewModel {
    /**
     * 
     * @type {ResultStates}
     * @memberof ResultOfListOfIntermediaryClientRelationshipViewModel
     */
    resultState: ResultStates;
    /**
     * 
     * @type {string}
     * @memberof ResultOfListOfIntermediaryClientRelationshipViewModel
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultOfListOfIntermediaryClientRelationshipViewModel
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ResultOfListOfIntermediaryClientRelationshipViewModel
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultOfListOfIntermediaryClientRelationshipViewModel
     */
    detail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultOfListOfIntermediaryClientRelationshipViewModel
     */
    errors: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ResultOfListOfIntermediaryClientRelationshipViewModel
     */
    validationErrors: { [key: string]: Array<string>; };
    /**
     * 
     * @type {Array<IntermediaryClientRelationshipViewModel>}
     * @memberof ResultOfListOfIntermediaryClientRelationshipViewModel
     */
    data?: Array<IntermediaryClientRelationshipViewModel>;
    /**
     * 
     * @type {number}
     * @memberof ResultOfListOfIntermediaryClientRelationshipViewModel
     */
    count: number;
}

/**
 * Check if a given object implements the ResultOfListOfIntermediaryClientRelationshipViewModel interface.
 */
export function instanceOfResultOfListOfIntermediaryClientRelationshipViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resultState" in value;
    isInstance = isInstance && "errors" in value;
    isInstance = isInstance && "validationErrors" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ResultOfListOfIntermediaryClientRelationshipViewModelFromJSON(json: any): ResultOfListOfIntermediaryClientRelationshipViewModel {
    return ResultOfListOfIntermediaryClientRelationshipViewModelFromJSONTyped(json, false);
}

export function ResultOfListOfIntermediaryClientRelationshipViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfListOfIntermediaryClientRelationshipViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultState': ResultStatesFromJSON(json['ResultState']),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'detail': !exists(json, 'Detail') ? undefined : json['Detail'],
        'errors': json['Errors'],
        'validationErrors': json['ValidationErrors'],
        'data': !exists(json, 'Data') ? undefined : ((json['Data'] as Array<any>).map(IntermediaryClientRelationshipViewModelFromJSON)),
        'count': json['Count'],
    };
}

export function ResultOfListOfIntermediaryClientRelationshipViewModelToJSON(value?: ResultOfListOfIntermediaryClientRelationshipViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ResultState': ResultStatesToJSON(value.resultState),
        'Type': value.type,
        'Status': value.status,
        'Title': value.title,
        'Detail': value.detail,
        'Errors': value.errors,
        'ValidationErrors': value.validationErrors,
        'Data': value.data === undefined ? undefined : ((value.data as Array<any>).map(IntermediaryClientRelationshipViewModelToJSON)),
        'Count': value.count,
    };
}

